import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import MotivoMovimentacaoEstoqueModel from "@/models/motivoMovimentacaoEstoque";
import MotivoMovimentacaoEstoqueService from "@/services/motivoMovimentacaoEstoque";

import ListComponentBase from "../listComponentBase";

@Component
export default class MotivoMovimentacaoEstoqueListComponent extends ListComponentBase<MotivoMovimentacaoEstoqueModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", "Descrição", GridColumnType.String),
            new GridColumn("tipoMotivoDescricao", "Tipo motivo movimentação", GridColumnType.String),
        ];
    }

    private beforeMount() {
        this.setProps(new MotivoMovimentacaoEstoqueService(), "motivomovimentacaoestoque", "descricao");
    }
}
